import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_number_input = _resolveComponent("number-input")!

  return (_openBlock(), _createBlock(_component_number_input, {
    maxlength: _ctx.maxLength,
    placeholder: _ctx.placeholder,
    addonAfter: _ctx.addonAfter,
    disabled: _ctx.disabled,
    value: _ctx.inputValue,
    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputValue) = $event))
  }, null, 8, ["maxlength", "placeholder", "addonAfter", "disabled", "value"]))
}